import type { ApiEnvelope } from '@/api/errors';
import type { AgentBreakdown, AgentDeals, AgentMarket } from '@/types/agentAnalytics';
import { BaseService } from './BaseService';

// Раздел «Рынок» агента (order-service /order/agent/*). Доступ — роль AGENT (403 иначе).
// Конверт { success, data }. Чтения идемпотентны (безопасный retry в транспорте).
class AnalyticsService extends BaseService {
  /** «Рынок сейчас» по культурам — текущее состояние офферов/прайс-листов (период не применяется). */
  async getMarket(signal?: AbortSignal): Promise<AgentMarket> {
    const response = await this.request<ApiEnvelope<AgentMarket>>(
      { method: 'get', url: '/order/agent/market' },
      { idempotent: true, signal },
    );
    return this.unwrap(response.data, response.status);
  }

  /** Закрытые сделки за период [from, to) по культуре (to — исключительно; даты ISO yyyy-MM-dd). */
  async getDeals(params: { from: string; to: string; goodsType?: string | null }, signal?: AbortSignal): Promise<AgentDeals> {
    const response = await this.request<ApiEnvelope<AgentDeals>>(
      {
        method: 'get',
        url: '/order/agent/deals',
        params: {
          from: params.from,
          to: params.to,
          ...(params.goodsType ? { goodsType: params.goodsType } : {}),
        },
      },
      { idempotent: true, signal },
    );
    return this.unwrap(response.data, response.status);
  }

  /** Drill-down рынка по культуре: классы качества и предоплата (sell-офферы). */
  async getBreakdown(goodsType: string, signal?: AbortSignal): Promise<AgentBreakdown> {
    const response = await this.request<ApiEnvelope<AgentBreakdown>>(
      { method: 'get', url: '/order/agent/breakdown', params: { goodsType } },
      { idempotent: true, signal },
    );
    return this.unwrap(response.data, response.status);
  }
}

export const analyticsService = new AnalyticsService();
